import React from 'react';
import { I18n } from 'react-redux-i18n';

import { downloadPostPdf, setRead } from 'api/articles';
import { isMobile } from 'react-device-detect';

const ActionsContainer = ({
  id,
  content,
  is_read,
  is_favorite,
  onReadClick,
  onShareClick,
  toggleFavorite,
  handleLoading,
  downloadIcon,
  openOusideIcon,
  shareIcon,
  favoriteIcon,
  nofavoriteIcon
}: {
  id: number;
  content: any;
  is_read: boolean;
  is_favorite: boolean;
  // eslint-disable-next-line no-unused-vars,@typescript-eslint/no-unused-vars
  onReadClick: (e: number) => void;
  // eslint-disable-next-line no-unused-vars,@typescript-eslint/no-unused-vars
  onShareClick: (e: number) => void;
  // eslint-disable-next-line no-unused-vars,@typescript-eslint/no-unused-vars
  toggleFavorite: (e: number) => void;
  // eslint-disable-next-line no-unused-vars,@typescript-eslint/no-unused-vars
  handleLoading: (e: boolean) => void;
  // it's can't be imported here, not working .tsx
  downloadIcon: any;
  openOusideIcon: any;
  shareIcon: any;
  favoriteIcon: any;
  nofavoriteIcon: any;
}) => {
  const downloadPdf = async (id: number) => {
    handleLoading(true);
    await downloadPostPdf(id);
    await setRead(id);
    onReadClick(id);
    handleLoading(false);
  };

  const canOpenOutside = !content.is_paper && content.url && content.url !== '';
  return (
    <div className="actionsContainer">
      <div className="actionButtonContainer" onClick={() => downloadPdf(id)}>
        <img
          src={downloadIcon}
          alt="download"
          className="icon-article-action"
        />
      </div>
      <div>
        <a
          href={canOpenOutside ? content.url : ''}
          target="_blank"
          rel="noopener noreferrer"
          className={[
            'actionButtonContainer',
            !canOpenOutside ? 'disabled' : ''
          ].join(' ')}
          aria-disabled={!canOpenOutside}
          download={content.is_paper || content.is_extract}
          onClick={!is_read ? () => onReadClick(id) : undefined}
        >
          {!isMobile && (
            <div className="tooltip-link">
              {I18n.t('media.articleList.tooltipLink')}
            </div>
          )}
          <img
            src={openOusideIcon}
            alt="resize"
            className="icon-article-action"
          />
        </a>
      </div>
      <div
        className={[
          'actionButtonContainer',
          content.url === '' ? 'disabled' : ''
        ].join(' ')}
        onClick={() => {
          if (content.url === '') return;
          onShareClick(id);
        }}
      >
        <img src={shareIcon} alt="share" className="icon-article-action" />
      </div>
      <div className="actionButtonContainer" onClick={() => toggleFavorite(id)}>
        <img
          src={is_favorite ? favoriteIcon : nofavoriteIcon}
          alt="star-favoris"
          className="icon-article-action star"
        />
      </div>
    </div>
  );
};

export default ActionsContainer;
